export const RECENT_GIFS_CACHE_KEY = 'recentGifs';
export const SEARCH_URL = `https://api.giphy.com/v1/gifs/search`;
